const PenIcon = (props) => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g opacity="0.8" clipPath="url(#clip0_6618_16388)">
            <path d="M4.5 10.8554V12.2063C4.5 12.3307 4.59776 12.4285 4.72219 12.4285H6.07311C6.13088 12.4285 6.18865 12.4062 6.22865 12.3618L11.0813 7.51359L9.41487 5.84716L4.56666 10.6954C4.52222 10.7398 4.5 10.7931 4.5 10.8554ZM12.37 6.22488C12.5433 6.05157 12.5433 5.77161 12.37 5.5983L11.3302 4.55845C11.1569 4.38514 10.8769 4.38514 10.7036 4.55845L9.89036 5.37167L11.5568 7.0381L12.37 6.22488Z" />
        </g>
        <defs>
            <clipPath id="clip0_6618_16388">
                <rect
                    width="16"
                    height="16"
                    fill="currentColor"
                    transform="translate(0.5 0.428467)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default PenIcon;
